
import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import './MedicalOfficerMenu.css';


const MedicalOfficerMenu = () => {

    let items: MenuItem[] = [
        {
            label: 'Applications', icon: 'pi pi-users', url: '/medi/medicalofficerapplications'
        },
        {
            label: 'Activities', icon: '', url: '/medi/mactivity'
        },
        




    ];
    const handleItemClick = (event: { item: { url: string } }) => {
        if (event.item.url) {
            window.location.href = event.item.url;
        }
    };

    return (
        <aside className="main-sidebar" >
            <div className=" menu">
                <div className="menu-container" style={{margin:'0px 10px'}}>
                    <PanelMenu model={items} style={{backgroundColor:'#fff'}}/>
                    {/* <PanelMenu model={items} onClick={() => handleItemClick} style={{width:'980px',textAlign:'center'}} />  */}

                </div>
            </div>
        </aside>
    );
};

export default MedicalOfficerMenu;
